// 移动端基于Vant开发
import { Toast } from "vant";

export const mbToastLoading = (msg = "") => {
  Toast.loading({
    message: msg,
    forbidClick: true,
    duration: 0
  });
};

export const mbToastClose = () => {
  Toast.clear();
};

export const mbToastFail = msg => {
  Toast.fail({
    message: msg
  });
};

export const mbToastSuccess = msg => {
  Toast.success({
    message: msg
  });
};
